import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the AssignmentQuotaView.
 * @extends JetView
 */
export default class AssignmentQuotaView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var url = devConfig.geturlApi() + 'es/Agent/AssignmentQuotaMade'; // API endpoint for assignment quota
        var filter; // Variable to hold filter data

        // Event listener for filtering the table
        this.on(this.app, 'filter:table', (data) => {
            filter = data; // Update filter variable with data
        });

        // Custom data filter for summing tree column
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable for formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) result += obj[value.columnId]; // Sum values at level 1
                    });
                    // Format result based on column ID
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        resultFormat = webix.i18n.priceFormat(result);
                    }
                    node.firstChild.innerHTML = resultFormat; // Update node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extend existing summColumn filter
        );

        // Return the main layout configuration
        return {
            rows: [
                {
                    view: 'datatable', // Data table view
                    id: 'datatable', // Unique ID for the datatable
                    css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                    select: true, // Enable row selection
                    columns: [
                        {
                            id: 'detailTittle', // Column ID
                            header: '', // Column header
                            width: 50, // Column width
                            height: 25, // Column height
                            tooltip: _('Anular Transferencia'), // Tooltip text
                            hidden: !devConfig.getPermAction('cancelAssignmentQuotaMade', 'Torefuse'), // Hide column based on permission
                            template: function (obj) {
                                // Template for rendering the cancel icon
                                if (obj.AllowCancelTransaction == true) {
                                    return "<span class='webix_icon wxi-close torefuse prm-cancelAssignmentQuotaMade'></span>";
                                } else {
                                    return '';
                                }
                            },
                        },
                        { id: 'Id', header: _('Id'), width: 100, sort: 'int' }, // ID column
                        { id: 'Date', header: _('Fecha'), width: 150 }, // Date column
                        {
                            id: 'UserId',
                            header: _('ID Usuario'),
                            width: 100,
                            sort: 'int', // Sort by integer
                        },
                        {
                            id: 'UserName',
                            header: _('Nombre del usuario'),
                            width: 150,
                            hidden: !devConfig.getPermAction('sensitiveInformationNames', 'Add'), // Hide column based on permission
                        },
                        {
                            id: 'TypeQuota',
                            header: _('Tipo Cupo'), // Quota type column
                            editor: 'combo', // Combo editor for selection
                            options: [
                                { id: 'A', value: _('Apuestas') }, // Option A
                                { id: 'R', value: _('Recargas') }, // Option R
                            ],
                            width: 100,
                        },
                        {
                            id: 'TypeTransaction',
                            header: _('Tipo Transacción'), // Transaction type column
                            editor: 'combo', // Combo editor for selection
                            options: [
                                { id: 'E', value: _('Deposito') }, // Deposit option
                                { id: 'S', value: _('Salida') }, // Withdrawal option
                            ],
                            width: 150,
                        },
                        {
                            id: 'Amount',
                            header: _('Valor'), // Amount column
                            format: webix.i18n.priceFormat, // Formatting function
                            exportType: 'number', // Export type
                            width: 100,
                        },
                        { id: 'Currency', header: _('Moneda'), width: 100 }, // Currency column
                        {
                            id: 'Assigned',
                            header: _('Asignado Por'), // Assigned by column
                            width: 200,
                        },
                        {
                            id: 'NameBank',
                            header: _('Información de banco'), // Bank information column
                            width: 200,
                        },
                        {
                            id: 'transactionId',
                            header: _('Id transacción'), // Transaction ID column
                            width: 200,
                        },
                    ],
                    onClick: {
                        torefuse: function (euv, id) {
                            var vvthis = this; // Reference to the current context
                            webix
                                .ui({
                                    view: 'window', // Create a modal window
                                    head: _('Desea Anular Transferencia?'), // Window header
                                    modal: true, // Modal window
                                    position: 'center', // Center position
                                    body: {
                                        view: 'form', // Form inside the window
                                        id: 'windowTransfersForm', // Form ID
                                        elements: [
                                            {
                                                view: 'text',
                                                label: _('Descripción'), // Description field
                                                labelPosition: 'top',
                                                name: 'Description',
                                                required: true, // Required field
                                            },
                                            {
                                                cols: [
                                                    {
                                                        view: 'button',
                                                        value: _('Cancelar'), // Cancel button
                                                        click: function (elementId, event) {
                                                            this.getTopParentView().hide(); // Hide window on cancel
                                                        },
                                                    },
                                                    {
                                                        view: 'button',
                                                        value: _('Aceptar'), // Accept button
                                                        click: function (elementId, event) {
                                                            const ethis = this; // Reference to the current context
                                                            var item = vvthis.getItem(id); // Get the item from the datatable
                                                            var values = $$('windowTransfersForm').getValues(); // Get form values
                                                            if ($$('windowTransfersForm').validate()) {
                                                                // Validate form
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json',
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'es/Agent/CancelAssignmentQuotaMade',
                                                                        '{ "Id":' +
                                                                            item.Id +
                                                                            ',"Description":"' +
                                                                            values.Description +
                                                                            '"}', // Send request to cancel assignment
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                webix.message(_('Error! ')); // Show error message
                                                                                this.getTopParentView().hide(); // Hide window on error
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                var dat = JSON.parse(text); // Parse response
                                                                                if (dat.HasError) {
                                                                                    webix.message({
                                                                                        title: '¡Error!',
                                                                                        type: 'alert-error',
                                                                                        text: _(dat.AlertMessage), // Show error message from response
                                                                                    });
                                                                                    ethis.getTopParentView().hide(); // Hide window on error
                                                                                } else {
                                                                                    webix.message(
                                                                                        _('Transferencia Anulada'), // Show success message
                                                                                    );
                                                                                    $$('datatable').clearAll(); // Clear datatable
                                                                                    $$('datatable').load(
                                                                                        url +
                                                                                            '?start=0&count=' +
                                                                                            $$('datatable').data
                                                                                                .$pagesize +
                                                                                            filter,
                                                                                    ); // Reload datatable with updated data
                                                                                    ethis.getTopParentView().hide(); // Hide window on success
                                                                                }
                                                                            },
                                                                        },
                                                                    );
                                                            } else {
                                                                webix.message({
                                                                    title: _('¡Error!'),
                                                                    type: 'alert-error',
                                                                    text: _(
                                                                        'Completa los campos...', // Show validation error message
                                                                    ),
                                                                });
                                                            }
                                                        },
                                                    },
                                                ],
                                            },
                                        ],
                                        elementsConfig: {
                                            on: {
                                                onChange: function () {
                                                    this.validate(); // Validate form on change
                                                },
                                            },
                                        },
                                    },
                                    move: true, // Allow moving the window
                                })
                                .show(); // Show the modal window
                        },
                    },
                    tooltip: true, // Enable tooltips
                    math: true, // Enable math operations
                    loadahead: 0, // Load ahead configuration
                    datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                    pager: 'pagerA', // Pager ID
                    on: {
                        onBeforeLoad: function () {
                            this.showOverlay(
                                "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                            ); // Show loading overlay before data load
                        },
                        onAfterLoad: function () {
                            this.hideOverlay(); // Hide loading overlay after data load
                        },
                    },
                    ready: function () {
                        if (!this.count()) {
                            webix.extend(this, webix.OverlayBox); // Extend with overlay box
                            this.showOverlay(
                                "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                    _('No hay datos') + // Show no data message
                                    '</div>',
                            );
                        }
                    },
                },
                {
                    view: 'treetable', // Tree table view
                    id: 'treetable', // Unique ID for the tree table
                    tooltip: true, // Enable tooltips
                    scrollY: true, // Enable vertical scrolling
                    footer: true, // Show footer
                    scheme: {
                        $group: {
                            by: 'Assigned', // Group by Assigned field
                            map: {
                                Amount: ['Amount', 'sum'], // Sum Amount for grouping
                                Currency: ['Currency'], // Currency field
                            },
                        },
                    },
                    columns: [
                        {
                            id: 'Assigned',
                            header: _('Asignado Por'), // Assigned by column
                            width: 250,
                            template: function (obj, common) {
                                if (obj.$group)
                                    return (
                                        common.treetable(obj, common) + obj.value // Render group value
                                    );
                                return '';
                            },
                            footer: _('Total:'), // Footer label
                        },
                        { id: 'Date', header: _('Fecha'), width: 150 }, // Date column
                        {
                            id: 'TypeQuota',
                            header: _('Tipo Cupo'), // Quota type column
                            editor: 'combo', // Combo editor for selection
                            options: [
                                { id: 'A', value: _('Apuestas') }, // Option A
                                { id: 'R', value: _('Recargas') }, // Option R
                            ],
                            width: 100,
                        },
                        {
                            id: 'TypeTransaction',
                            header: _('Tipo Transacción'), // Transaction type column
                            editor: 'combo', // Combo editor for selection
                            options: [
                                { id: 'E', value: _('Deposito') }, // Deposit option
                                { id: 'S', value: _('Salida') }, // Withdrawal option
                            ],
                            width: 150,
                        },
                        {
                            id: 'Amount',
                            header: _('Valor'), // Amount column
                            format: webix.i18n.priceFormat, // Formatting function
                            footer: { content: 'summTreeColumn' }, // Footer content for summation
                            exportType: 'number', // Export type
                            width: 100,
                        },
                        { id: 'Currency', header: _('Moneda'), width: 100 }, // Currency column
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'es/Agent/AssignmentQuotaMade'; // API endpoint for assignment quota
        var filter = ''; // Initialize filter variable
        var grid = $$('datatable'); // Reference to the datatable
        var grid2 = $$('treetable'); // Reference to the tree table
        grid2.hide(); // Hide tree table initially
        $$('toolbar2').hide(); // Hide secondary toolbar

        // Event listener for assignment quota filtering
        this.on(this.app, 'assignmentQuota:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            var typeTable = 0; // Initialize table type variable
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'Type') {
                    if (object[i][1] == 1) {
                        typeTable = 1; // Set table type based on filter
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                        } else {
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested filter data to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear datatable
            if (typeTable == 0) {
                grid.show(); // Show datatable
                grid2.hide(); // Hide tree table
                grid.clearAll(); // Clear datatable
                grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data into datatable
                $$('toolbar').show(); // Show primary toolbar
                $$('toolbar2').hide(); // Hide secondary toolbar
            } else {
                grid2.show(); // Show tree table
                grid.hide(); // Hide datatable
                grid2.clearAll(); // Clear tree table
                grid2.showOverlay(
                    "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                ); // Show loading overlay for tree table
                webix
                    .ajax()
                    .headers({
                        'Content-type': 'application/json',
                    })
                    .get(
                        devConfig.geturlApi() + 'es/Agent/AssignmentQuotaMade?' + string1, // Send request to load data for tree table
                        {
                            success: function (text, data, XmlHttpRequest) {
                                var resp = JSON.parse(text); // Parse response
                                grid2.clearAll(); // Clear tree table
                                if (!resp.HasError && resp.Data != undefined && resp.Data.length > 0) {
                                    grid2.parse(resp.Data); // Parse and load data into tree table
                                    grid2.hideOverlay(); // Hide loading overlay
                                }
                            },
                        },
                    );
                $$('toolbar2').show(); // Show secondary toolbar
                $$('toolbar').hide(); // Hide primary toolbar
            }
            filter = string1; // Update filter variable
            this.app.callEvent('filter:table', [filter]); // Trigger filter event
            $$('filterPopup').hide(); // Hide filter popup
        });
    }
}

// FILE DOCUMENTED
